import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCaretListRightProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCaretListRightSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCaretListRightSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M6.61999 12.4933L5.45999 11.3333L8.81333 7.99329L5.45999 4.64662L6.61999 3.49329L11.1267 7.99329L6.61999 12.4933Z" />
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCaretListRightSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M6.35333 12.3467L5.64667 11.6333L9.29333 7.99335L5.64667 4.34668L6.35333 3.64001L10.7067 7.99335L6.35333 12.3467Z" />
    </svg>
  );
}

export default function IconCaretListRight({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCaretListRightProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
